module.exports = "https://coursera_assets.s3.amazonaws.com/images/e82d5b139d2cc2459fed51afbb3bb7aa.png";